const url = {
  login: '/api/ms/user/login.json',
  msgCode: '/api/ms/user/msgCode.json',
  mywallet: '/api/user/v1/mywallet.json',
  myOrderList: '/api/order/query/myOrderList.json',
  orderDetail: '/api/order/query/orderDetail.json',
  OrderPrice: '/api/consumebill/queryOrderPriceDetail.json',
  storeInfo: '/api/store/getStoreInfoByStoreId',
  feedback: '/api/user/feedback.json',
  initCityDic: '/api/urbanAreacity/getDredgeCityDicList.json',
  storeListByCityId: '/api/store/getStoreInfoAreaListByCityId.json',
  cancelReason: '/api/order/cancel/cancelReason.json',
  byCustomer: '/api/order/cancel/byCustomer.json',
  findAdInfoList: '/api/adInfo/findAdInfoList.json',
  getCarLevelList: '/api/asset/getCarLevelList.json',
  getOrderConfigs: '/api/rentorder/getOrderConfigs.json',
  getStockVehicleList: '/api/asset/getStockVehicleList.json',
  getCarModelDetail: '/api/asset/getCarModelDetail.json',
  makeShortOrderCheck: '/api/rentorder/makeShortOrderCheck.json',
  getSameCityReplaceByStorePoint: '/api/store/getSameCityReplaceByStorePoint.json',
  findPriceCalendar: '/api/rentPrice/findPriceCalendar.json',
  couponList: '/api/coupon/query/availableCouponList.json',
  auth: '/api/ali/program/auth',
  getCity: '/api/urbanAreacity/getCityDicByLogAndlat.json',
  orderPage: '/api/rentorder/preShortOrder.json',
  useCoupon: '/api/coupon/query/availableQuantity.json',
  submitOrder: '/api/rentorder/makeShortOrder.json',
  getPayInfo:'/api/payment/pay/v1/confirm.json',
  payTypezf:'/api/payment/pay/v2/method/get.json',
  getHomePageStoreInfoByStorePointAndCityId:'/api/store/getHomePageStoreInfoByStorePointAndCityId.json',
  mycouponList: '/api/coupon/query/couponList.json',
  queryNotCompletedNumJson: '/api/remind/queryNotCompletedNum.json',
  bookingOpenTimeCheck: '/api/rentorder/bookingOpenTimeCheck.json',
  searchPayResult: '/api/payment/pay/v1/result/query.json',
  FreeAccess:'/api/ms/user/tokenLogin.json'
}
export default url;